import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import * as ReactDOM from 'react-dom/client';
import App from './app';
import AppError from './app.error';

import {HashRouter as Router} from 'react-router-dom';

import {Provider} from 'react-redux';
import {store, persistor, clearStorage} from './redux/configure.store';
//redux persist
import {PersistGate} from 'redux-persist/integration/react';

import config from './config';

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);

const reset = () => {
    persistor
        .purge()
        .then(() => persistor.flush())
        .then(() => {
            setTimeout(() => window.location.reload(), 100);
        });
};

config.setBackendUrl(rootElement.getAttribute('data-backend-url'));
const params = {};
rootElement.getAttributeNames().forEach(attr => {
    if (!attr.match(/data-/)) return;

    params[attr.replace('data-', '').replace(/-/g, '_')] = rootElement.getAttribute(attr);
});

root.render(
    <AppError reset={reset}>
        <Provider store={store}>
            <Router>
                <PersistGate loading={null} onBeforeLift={clearStorage} persistor={persistor}>
                    <App {...params}/>
                </PersistGate>
            </Router>
        </Provider>
    </AppError>);
